(() => {
  if (window.PopupCartDrawerRefreshLoaded) return;
  window.PopupCartDrawerRefreshLoaded = true;

  const ADD_BUTTON_SELECTORS = [
    '[data-popup-add-to-cart]',
    '.popup-add-to-cart',
    '.variant-popup-add-to-cart',
    '.quick-add-modal button[type="submit"]',
    'quick-add-modal button[type="submit"]'
  ];

  const POPUP_SELECTORS = [
    '.variant-popup',
    '.product-popup',
    '.quick-add-modal',
    'quick-add-modal',
    'modal-dialog'
  ];

  async function addToCart(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
    }

    return data;
  }

  async function refreshCartDrawer() {
    const response = await fetch(
      `/cart?sections=cart-drawer,cart-icon-bubble&sections_url=${encodeURIComponent(window.location.pathname)}`
    );

    const sections = await response.json();

    const parser = new DOMParser();

    if (sections['cart-drawer']) {
      const newDrawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const newCartDrawer = newDrawerDoc.querySelector('cart-drawer');
      const currentCartDrawer = document.querySelector('cart-drawer');

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        currentCartDrawer.className = newCartDrawer.className;
      }
    }

    if (sections['cart-icon-bubble']) {
      const newBubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const newBubble = newBubbleDoc.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  function getVariantId(button) {
    const popup = button.closest(POPUP_SELECTORS.join(','));
    const scope = popup || document;

    const checkedVariant = scope.querySelector('input[name="id"]:checked');
    if (checkedVariant?.value) return checkedVariant.value;

    const hiddenVariant = scope.querySelector('input[name="id"]');
    if (hiddenVariant?.value) return hiddenVariant.value;

    const selectVariant = scope.querySelector('select[name="id"]');
    if (selectVariant?.value) return selectVariant.value;

    if (button.dataset.variantId) return button.dataset.variantId;

    return null;
  }

  function getQuantity(button) {
    const popup = button.closest(POPUP_SELECTORS.join(','));
    const scope = popup || document;

    const quantityInput = scope.querySelector('input[name="quantity"]');
    return quantityInput?.value || 1;
  }

  function closePopup(button) {
    const popup = button.closest(POPUP_SELECTORS.join(','));

    if (!popup) return;

    if (typeof popup.hide === 'function') {
      popup.hide(true);
      return;
    }

    const closeButton = popup.querySelector(
      '.modal__close-button, .quick-add-modal__toggle, [data-modal-close], .popup-close, button[aria-label="Close"], button[aria-label="Kapat"]'
    );

    if (closeButton) {
      closeButton.click();
      return;
    }

    popup.removeAttribute('open');
    popup.classList.remove('active', 'is-active', 'open');
    document.body.classList.remove('overflow-hidden');
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      window.location.href = '/cart';
      return;
    }

    cartDrawer.classList.remove('is-empty');

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  }

  function showError(button, message) {
    const popup = button.closest(POPUP_SELECTORS.join(','));
    const scope = popup || document;

    let errorBox = scope.querySelector('.popup-cart-error');

    if (!errorBox) {
      errorBox = document.createElement('div');
      errorBox.className = 'popup-cart-error';
      errorBox.style.marginTop = '12px';
      errorBox.style.color = '#b00020';
      errorBox.style.fontSize = '14px';
      button.insertAdjacentElement('afterend', errorBox);
    }

    errorBox.textContent = message;
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest(ADD_BUTTON_SELECTORS.join(','));
    if (!button) return;

    const popup = button.closest(POPUP_SELECTORS.join(','));
    if (!popup) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = getVariantId(button);
    const quantity = getQuantity(button);

    if (!variantId) {
      showError(button, 'Lütfen bir varyant seçin.');
      return;
    }

    button.disabled = true;
    button.classList.add('loading');

    try {
      await addToCart(variantId, quantity);
      await refreshCartDrawer();
      closePopup(button);
      setTimeout(openCartDrawer, 150);
    } catch (error) {
      showError(button, error.message || 'Ürün sepete eklenirken hata oluştu.');
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();